/* eslint-disable import/prefer-default-export */

// Given an array of string keys, returns an object with those keys, and values set to `value`
export const keysToObject = (keys, value) => {
  if (keys != null && !Array.isArray(keys)) throw new Error('Parameter "keys" is not of type array.');
  return (keys || []).reduce((acc, key) => {
    acc[key] = value;
    return acc;
  }, {});
};
